module.exports = __webpack_public_path__ + "img/jiaoyishichang.b303cddc.png";